module.exports = __webpack_public_path__ + "static/media/module-puzzle.4ea0dce3.svg";